const Cookie = require('react-cookie').Cookies;
const cookieParams = require('../../utils/cookieParams');

const cookie = new Cookie();

const onRouteUpdate = ({ location, prevLocation }) => {
  const previous = prevLocation ? prevLocation.pathname : 'Direct';
  cookie.set('referrer', previous, cookieParams);
  cookie.set('conversionPage', location.pathname, cookieParams);
};

module.exports = onRouteUpdate;
